"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBMISSION_REJECTION = exports.SUBMISSION_THANKS = exports.MORE_DETAILS = exports.EMPLOYMENT = exports.HOUSING = exports.HOUSEHOLD = exports.MOVE_DETAILS = exports.PERSONAL_INFO = exports.ELIGIBILITY = void 0;
exports.ELIGIBILITY = "ELIGIBILITY";
exports.PERSONAL_INFO = "PERSONAL_INFO";
exports.MOVE_DETAILS = "MOVE_DETAILS";
exports.HOUSEHOLD = "HOUSEHOLD";
exports.HOUSING = "HOUSING";
exports.EMPLOYMENT = "EMPLOYMENT";
exports.MORE_DETAILS = "MORE_DETAILS";
exports.SUBMISSION_THANKS = "SUBMISSION_THANKS";
exports.SUBMISSION_REJECTION = "SUBMISSION_REJECTION";
